import React, { Component } from 'react';
import { Grid, Row, Media, ProgressBar } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './ProjectCard.css';

class ProjectCard extends Component {

    renderImpact(type, impactTargets, volunteer) {
        switch (type) {
            case 'volunteer':
                return (<Media.Body align="bottom">
                    <p>
                        {volunteer.hours} hours over {volunteer.period} {volunteer.units}
                    </p>
                </Media.Body>);
            default:
                const donateGoal = impactTargets.donateGoal / 100;
                return (<Media.Body align="bottom">
                    <p>
                        {impactTargets.donateCurrentPct.toFixed(0) + '%'} of ${donateGoal.toLocaleString('en')} funded
                        <br />
                        {/* $700 = 1 well */}
                    </p>
                    <ProgressBar bsStyle="warning" now={impactTargets.donateCurrentPct} className="project-home-card-progress" />
                </Media.Body>);
        }
    }

    render () {

        if (!this.props.project) {
            return (
                <span></span>
            )
        }

        const {
            _id,
            projectId,
            type,
            title,
            imageProfile,
            shortDescription,
            impactTargets,
            volunteer,
            charity,
            categories
        } = this.props.project;

        const style = {
            backgroundImage: `url(${imageProfile})`,
            backgroundPosition: 'center center no-repeat',
            backgroundSize: 'cover',
            width: '100%',
            height: '150px'
        };

        return (
            <Link to={`/projects/${projectId}`}>
            <div className="project-home-card-main tikki-shadow">
                    <Grid fluid={true}>
                        <Row className="show-grid">
                            <div className="tikki-filter" style={style}></div>
                        </Row>
                        <Row className="show-grid project-home-card-body">
                            <Media>
                                <Media.Body>
                                    <Media.Heading>{title}</Media.Heading>
                                    <p>
                                    {shortDescription}
                                    </p>
                                </Media.Body>
                                <Media.Right>
                                    {categories.map((category, index) => (
                                        <img
                                            key={category.categoryId}
                                            className="project-home-card-sm-logo responsive-img"
                                            src={category.imageLogo}
                                            alt={category.title}
                                        />
                                    ))}
                                </Media.Right>
                            </Media>
                        </Row>
                        <Row className="show-grid project-home-card-footer">
                            <Media>
                                {this.renderImpact(type, impactTargets, volunteer)}
                                <Media.Right align="bottom">
                                    <img
                                        className="project-home-card-md-logo responsive-img"
                                        src={charity[0].imageLogo}
                                        alt=""
                                    />
                                </Media.Right>
                            </Media>
                        </Row>
                    </Grid>
            </div>
            </Link>
        );
    };
};

export default ProjectCard;



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectCard.js